import { Route } from '@lumapps/router';
import { AppId } from '@lumapps/router/constants';

export const digitalAssistantAdminRoute: Route = {
    path: '/admin/digital-assistant',
    legacyId: 'app.admin.digital-assistant',
    appId: AppId.backOffice,
};
